import { emailLeakMapper } from '../mappers/email-leak-mapper';
import { trackedEmailMapper } from '../mappers/tracked-email-mapper';
import { trackedEmailWithBreachesMapper } from '../mappers/tracked-email-with-breaches-mapper';
import { apiClient } from '../shared/api-client';

const dataBreachRepository = {
    async getEmailLeaks(email) {
        try {
            const data = await apiClient.get({
                url: `data-breaches/${email}`,
                isCheckAccessToken: true
            });

            return data.map(emailLeakMapper.toDomain);
        } catch (error) {
            throw error;
        }
    },

    async getTrackedEmails() {
        try {
            const data = await apiClient.get({
                url: `data-breaches/tracked-emails`,
                isCheckAccessToken: true
            });

            return data.map(trackedEmailMapper.toDomain);
        } catch (error) {
            throw error;
        }
    },

    async getBreaches(id) {
        try {
            const data = await apiClient.get({
                url: `data-breaches/tracked-emails/${id}`,
                isCheckAccessToken: true
            });

            return trackedEmailWithBreachesMapper.toDomain(data);
        } catch (error) {
            throw error;
        }
    },

    async toggleResolution(id, body) {
        try {
            await apiClient.patch({
                url: `data-breaches/${id}`,
                isCheckAccessToken: true,
                body
            });

            return true;
        } catch (error) {
            throw error;
        }
    }
};
  
export {
    dataBreachRepository
};
